import { render, staticRenderFns } from "./GrayInfo.vue?vue&type=template&id=770b5eec&scoped=true&"
import script from "./GrayInfo.vue?vue&type=script&lang=ts&"
export * from "./GrayInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GrayInfo.vue?vue&type=style&index=0&id=770b5eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770b5eec",
  null
  
)

export default component.exports